
export interface NotificationEmailProps {
  recipient: string;
  subject: string;
  message: string;
  reportStatus: string;
  rejectionComments?: string;
}

export const sendNotificationEmail = async (props: NotificationEmailProps) => {
  try {
    console.log('Sending notification email to:', props.recipient);
    
    const response = await fetch('/api/send-expense-report-notification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recipient: props.recipient,
        subject: props.subject,
        message: props.message,
        reportStatus: props.reportStatus,
        rejectionComments: props.rejectionComments
      }),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to send notification email');
    }
    
    console.log('Notification email sent successfully');
    return true;
  } catch (error) {
    console.error('Error sending notification email:', error);
    return false;
  }
};
